import { Journey } from '@/custom/menicon/models';
import { GenericService } from '@/services/api/generic.service';

export class PatientJourneyService extends GenericService<Journey> {
  constructor(patientId: string) {
    super(`/menicon/v1/patients/${patientId}/journeys`);
  }
}
